import React, { Component } from 'react';
import "./index.scss";

import { IGameResultHistoryProps } from "@/types/GameHistoryTypes";
import { assetImg } from "@/modules/moduleImporter";
import { ILanguageType } from "@/types/GlobalTypes";

interface IProps extends IGameResultHistoryProps {
	langdata: ILanguageType;
	activeGameCount: number;
}

//p12: Sicbo[Dice]
//m31: Sicbo Machine (3D)
//m37: Bingo Sicbo
export default class P12 extends Component<IProps> {
	smallBig: string[];
	oddEven: string[];

	constructor(props: IProps) {
		super(props);

		// console.log("props on GRH p12 constructor", props);
		switch (this.props.langdata.language_code) {
			case "cn":
				this.smallBig = ["小", "大"];
				this.oddEven = ["奇", "偶"];
				break;

			case "id":
				this.smallBig = ["K", "B"];
				this.oddEven = ["Ga", "Ge"];
				break;

			case "vn":
				// Nhỏ
				// Lớn

				// số lẻ
				// Số chẵn
				this.smallBig = ["Nh", "Lớ"];
				this.oddEven = ["lẻ", "chẵn"];
				break;

			case "th":
				// เล็ก
				// ยิ่งใหญ่

				// เลขคี่
				// เลขคู่
				this.smallBig = ["เล็ก", "ใหญ่"];
				this.oddEven = ["ขคี่", "ขคู่"];
				break;

			default:
				this.smallBig = ["S", "B"];
				this.oddEven = ["O", "E"];
				break;
		}
	}

	History(props) {
		const alternatingStyle = "sl-roadmap-alternating";

		const pcode = props.pcode;
		const assetExtension = pcode === "m31" ? ".svg" : "";

		const assetsImgpcode = pcode === "m37" ? "p12" : pcode;

		const angka = props.angka.split(',');

		const total = angka.slice(0).reduce((a, b) => Number(a) + Number(b));

		const size = (total > 3 && total <= 10) ? props.smallBig[0] :
			(total > 10 && total < 18) ? props.smallBig[1] : "-";
		
		const num = !(total % 2) ? props.oddEven[1] : props.oddEven[0];

		return (
			<div className={props.blink ? alternatingStyle : ""}>
				{assetImg(assetsImgpcode, angka[0] + assetExtension, "hist" + pcode + "_1")}
				{assetImg(assetsImgpcode, angka[1] + assetExtension, "hist" + pcode + "_2")}
				{assetImg(assetsImgpcode, angka[2] + assetExtension, "hist" + pcode + "_3")}
				{
					//Don't render anything if the three numbers are the same
					(angka[0] === angka[1] && angka[1] === angka[2]) ? [
						null, null
					] : [
							<div key={"p12_0"} className="sl-green-new">{size}</div>,
							<div key={"p12_1"} className="sl-cyan-new">{num}</div>
						]
				}
			</div>
		);
	}

	render() {
		//console.log("props on GRH p12", this.props);

		const History = this.History;
		const historyBlink = this.props.historyBlink;
		const history = this.props.history.slice(0).reverse();

		return (
			<div className={`history-container p12 ${this.props.pcode} ${this.props.langdata.language_code}`}>
				{
					this.props.activeGameCount === 1 ?
						history.slice(0, 7).map((data, idx) =>
							<History key={`p12_grh_${idx}`}
								pcode={this.props.pcode}
								angka={data.angka}
								blink={historyBlink && idx === 0}
								smallBig={this.smallBig}
								oddEven={this.oddEven} />
						) :
						history.slice(0, 5).map((data, idx) =>
							<History key={`p12_grh_${idx}`}
								pcode={this.props.pcode}
								angka={data.angka}
								blink={historyBlink && idx === 0}
								smallBig={this.smallBig}
								oddEven={this.oddEven} />
						)
				}
			</div>
		);
	}
}
